// Must match the API (src/api/alerts/alert-template.ts), which rejects anything
// this form would let through.
export const ALERT_QUESTIONS_HEADING = 'Questions for Newspagers';
export const MAX_INTRO_WORDS = 150;
export const MAX_QUESTIONS = 5;

export const countWords = (text = '') =>
    text.split(/\s+/).filter(Boolean).length;

// The intro is editor HTML. Inline tags can sit inside a word ("<b>Hel</b>lo");
// every other tag ends one.
export const introText = (html = '') =>
    html
        .replace(/<\/?(?:a|b|em|i|s|strong|u)\b[^>]*>/gi, '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ');

export const filledQuestions = (questions = []) =>
    questions.map((question) => question.trim()).filter(Boolean);

// Alerts written before the template have no questions and keep their free-form body.
export const alertTemplate = (alert) =>
    Array.isArray(alert?.questions)
        ? { intro: alert.intro || '', questions: alert.questions }
        : null;

const plainText = (html = '') => introText(html).replace(/\s+/g, ' ').trim();

// Same rule as the API: admins have no word limit, and neither has an author saving
// an intro (say, one an admin made longer) without changing its text.
export const introLimited = (intro, isAdmin = false, storedIntro = null) =>
    !isAdmin && !(storedIntro && plainText(intro) === plainText(storedIntro));

// The first reason the template cannot be sent, or null. Like the API, admins may send
// no questions, and so may an author saving an alert that already has none.
export const alertTemplateError = (
    { intro = '', questions = [] },
    isAdmin = false,
    storedIntro = null,
    storedQuestions = null
) => {
    const text = introText(intro);
    if (!text.trim()) return 'Write an intro.';
    if (
        introLimited(intro, isAdmin, storedIntro) &&
        countWords(text) > MAX_INTRO_WORDS
    )
        return `The intro must be ${MAX_INTRO_WORDS} words or fewer.`;
    if (
        filledQuestions(questions).length < 1 &&
        !isAdmin &&
        !(Array.isArray(storedQuestions) && storedQuestions.length === 0)
    )
        return 'Add at least one question.';
    return null;
};
